import theme from 'ThemeProvider/theme';
import sx from 'utils/createSx';

export default sx({
  container: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#f9f9f9',
  },
  secondaryHeader: {
    backgroundColor: theme.palette.primary.main,
    padding: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  menuButton: {
    display: { xs: 'block', sm: 'none' },
  },
  search: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(0.5, 1),
    flexGrow: 1,
    maxWidth: '300px',
    marginLeft: { xs: 0, sm: theme.spacing(2) },
  },
  searchInput: {
    flexGrow: 1,
  },
  drawer: {
    '& .MuiDrawer-paper': {
      width: 240,
    },
  },
  drawerContent: {
    width: 240,
    padding: theme.spacing(2),
  },
  banner: {
    backgroundColor: theme.palette.secondary.main,
    padding: theme.spacing(4),
    textAlign: 'center',
    color: theme.palette.common.white,
  },
  bannerText: {
    fontWeight: 'bold',
  },
  productsContainer: {
    flexGrow: 1,
    padding: theme.spacing(4),
  },
  productCard: {
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    borderRadius: 8,
  },
  price: {
    fontWeight: 'bold',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  addToCartButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  footer: {
    textAlign: 'center',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white,
  },
});
